import React, { useState, useEffect } from 'react';
import { SearchBar } from 'react-native-elements';
import { View, FlatList } from 'react-native';
import { ODictItem, ODictCompareItem } from '../olonkho-fw';
import { useWindowDimensions } from 'react-native';
import CompareItem from '../CompareItem';

export default function DictionaryPage({ route, navigation }) {
    const { items } = route.params;
    const { width } = useWindowDimensions();
    const [dictionary, setDictionary] = useState(items);
    const [searchText, setSearch] = useState("");

    useEffect(() => {
        if (searchText != "")
        {
            setDictionary(items.filter((item) => 
                (item.text.toLowerCase().indexOf(searchText.toLowerCase()) > -1) || (item.translate.toLowerCase().indexOf(searchText.toLowerCase()) > -1) 
            ));
        }
        else {
            setDictionary(items);
        }
    }, [searchText]);

    return (
        <View style={ { flex: 1 } }>
            <SearchBar 
                placeholder={ "Поиск..." }
                onChangeText={ (text) => {
                    setSearch(text);
                } }
                value={ searchText }
                lightTheme={ true }
            />
            <FlatList 
                data={ dictionary }
                renderItem={ (item) => {
                    if (item.item.type === "TYPE_SRAV" || item.item.type === "TYPE_EPICH") {
                        return (
                            <CompareItem item={ item.item } navigation={ navigation } width={ width }/>
                        );
                    }
                    else {
                        return (
                            <ODictItem item={ item.item } navigation={ navigation }/>
                        );
                    }
                } }
            />
        </View>
    );
}